import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import styles from '../../../utils/styles';

import './grid.scss';

export interface IGrid extends IComponent {
  childrenRail?: React.ReactNode;
  childrenHeader?: React.ReactNode;
  customWrapper?: string;
}

const Grid: React.FC<IGrid> = ({ children, childrenRail, childrenHeader, customWrapper = '' }) => (
  <div className={styles(`l-wrapper ${customWrapper}`)}>
    {childrenHeader}
    <div className={styles('l-grid')}>
      <div className={styles('l-grid__main')}>
        <div className={styles('l-inner-grid')}>
          {childrenRail}
          <div className={styles('l-inner-grid__main content-grid')}>{children}</div>
        </div>
      </div>
    </div>
  </div>
);

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Grid.propTypes = {
    children: PropTypes.node,
    childrenRail: PropTypes.node,
  };
}

export default Grid;
